exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ps-company-detail-load-more--hide{display:none}.ps-company-detail-load-more--show{display:block}.ps-company-detail-load-more--border{display:flex;justify-content:center;align-items:center;border-top:1px solid #F0F2F5;padding:16px}.ps-company-detail-load-more--no-border{display:flex;justify-content:center;align-items:center;border-top:none;padding:16px}.ps-company-detail-load-more--highlight{font-size:0.857rem;font-weight:600;cursor:pointer}.ps-company-detail-load-more--no-highlight{color:#7A8599;cursor:pointer}\n", ""]);

// exports
